/**
 * Generato automaticamente.
 * framework-cfg-utenti
 */
import { useMutation } from 'react-query';
import type { MutationFunction, UseMutationOptions } from 'react-query';
import { apiClientRequest } from '../../../client/apiClient';
import type { ErrorType } from '../../../client/apiClient';
import type { BEResponseWorkflowResponse, WorkflowEvent } from '.././schemas';

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

// eslint-disable-next-line
type SecondParameter<T extends (...args: any) => any> = T extends (
  config: any,
  args: infer P,
) => any
  ? P
  : never;

export const postAzioniDatiUfficio = (
  workflowEvent: WorkflowEvent,
  options?: SecondParameter<typeof apiClientRequest>,
) => {
  return apiClientRequest<BEResponseWorkflowResponse>(
    {
      url: `/framework-cfg-utenti/azioni/datiUfficio`,
      method: 'post',
      headers: { 'Content-Type': 'application/json' },
      data: workflowEvent,
    },
    options,
  );
};

export const getPostAzioniDatiUfficioMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAzioniDatiUfficio>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postAzioniDatiUfficio>>,
  TError,
  { data: WorkflowEvent },
  TContext
> => {
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postAzioniDatiUfficio>>,
    { data: WorkflowEvent }
  > = props => {
    const { data } = props ?? {};

    return postAzioniDatiUfficio(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostAzioniDatiUfficioMutationResult = NonNullable<
  Awaited<ReturnType<typeof postAzioniDatiUfficio>>
>;
export type PostAzioniDatiUfficioMutationBody = WorkflowEvent;
export type PostAzioniDatiUfficioMutationError = ErrorType<unknown>;

export const usePostAzioniDatiUfficio = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postAzioniDatiUfficio>>,
    TError,
    { data: WorkflowEvent },
    TContext
  >;
  request?: SecondParameter<typeof apiClientRequest>;
}) => {
  const mutationOptions = getPostAzioniDatiUfficioMutationOptions(options);

  return useMutation(mutationOptions);
};
